import { getStorageItem } from "../../_helpers";
import { userConstants } from "../_redux-constants";
import { getDataFromToken } from "../../_helpers";

let user = getStorageItem("user");
const initialState = user?.accessToken
  ? {
      loggedIn: true,
      user: {
        roles: getDataFromToken(user?.accessToken).roles,
        name: getDataFromToken(user?.accessToken).name,
      },
      loginError: null,
    }
  : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        loginError: null,
        user: action.user,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        loginError: null,
        user: action.user,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        loginError: action.error,
        loggedIn: false,
        user: null,
      };
    case userConstants.LOGOUT:
      return {};
    default:
      return state;
  }
}
